import React from 'react'
export const LicenceVersionContext = React.createContext()